/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from "react";
import { emptyFilters } from "./SearchFilters";
import type { ISearchData } from "./ISearchData";
import { SortingOrder } from "./SearchSorting";

const defaultContextData: ISearchData = {
  filteredContactsMetiers: [],
  deleteContactMetier: () => {},
  modifyContactMetier: () => {},
  modifyContactsMetiers: () => {},
  updateAllContactsMetiers: async () => {},
  isLoading: false,
  isContactsMetiersLoading: false,
  isPerimetresLoading: false,

  filters: emptyFilters,
  resetAllFilters: () => {},
  setFilters: () => {},

  order: SortingOrder.ASC,
  sortableTableHeads: [],
  setSortColumn: () => {},
};
export const SearchContext = createContext(defaultContextData);
